export enum StandardCalendarViewTypes {
  Daily = 'day',
  Weekly = 'week',
  Monthly = 'month',
}
